export default __webpack_public_path__ + "../images/mstile-150x150.png";